import { ActionCardsCallbacks, ActionCardsConfig, ActionCardsSettings } from '@playbooks/action-cards/types'
import { ActionCardData, ActionCardsElement } from '@playbooks/action-cards'
import ActionCards from '@playbooks/action-cards'
import { cn } from '@playbooks/ui/lib/utils'

import useHorizontalSliderMethods from '../hooks/useHorizontalSliderMethods'
import { SliderManager } from '../types'

interface ActionCardsViewProps {
  playbookId: string
  config: ActionCardsConfig
  actionCard: ActionCardData
  settings: ActionCardsSettings
  callbacks: ActionCardsCallbacks
  sliderManagerRef: React.RefObject<SliderManager | null>
  actionCardsElementRef: React.RefObject<ActionCardsElement | null>
  setIsFinishButtonVisible: (flag: boolean) => void
  setProgress: React.Dispatch<React.SetStateAction<number>>
}

function ActionCardsView({
  config,
  settings,
  callbacks,
  actionCard,
  playbookId,
  actionCardsElementRef,
  sliderManagerRef,
  setProgress,
  setIsFinishButtonVisible,
}: ActionCardsViewProps) {
  const scrollContainer = useHorizontalSliderMethods({
    playbookId,
    viewMode: settings.viewMode,
    sliderManagerRef: sliderManagerRef,
    setProgress,
    setIsFinishButtonVisible,
  })

  return (
    <div ref={scrollContainer} className={cn(`flex basis-auto overflow-hidden transition-[filter]`)}>
      <ActionCards
        config={config}
        value={actionCard}
        settings={settings}
        onInit={callbacks.onReady}
        ref={actionCardsElementRef}
        onChange={callbacks.onChange}
        onLastSlideVisible={callbacks.onLastSlideVisible}
      />
    </div>
  )
}

export default ActionCardsView
